import { createContext, useState } from 'react';

export const LayoutContext = createContext({
  showSidebar: false,
  onShowSidebar: (param: boolean) => {},
});

const LayoutProvider = (props: any) => {
  const [showSidebar, setShowSidebar] = useState(false);

  const onShowSidebar = (param: boolean) => {
    setShowSidebar(param);
  };

  return (
    <LayoutContext.Provider value={{ showSidebar, onShowSidebar }}>
      {props.children}
    </LayoutContext.Provider>
  );
};

export default LayoutProvider;
